export const CLAUDE_MODELS = [
  { value: 'anthropic.claude-haiku-4-5-20251001-v1:0', label: 'Claude Haiku 4.5 — fastest & cheapest' },
  { value: 'anthropic.claude-sonnet-4-6-v1:0', label: 'Claude Sonnet 4.6 — balanced' },
  { value: 'anthropic.claude-opus-4-6-v1:0', label: 'Claude Opus 4.6 — most capable' },
];

export const STT_PROVIDERS = [
  { value: 'transcribe', label: 'AWS Transcribe' },
];

export const TTS_PROVIDERS = [
  { value: 'polly', label: 'AWS Polly' },
];

export const POLLY_VOICES = [
  { value: 'Joanna', label: 'Joanna (Female, US English)' },
  { value: 'Matthew', label: 'Matthew (Male, US English)' },
  { value: 'Salli', label: 'Salli (Female, US English)' },
  { value: 'Joey', label: 'Joey (Male, US English)' },
  { value: 'Kendra', label: 'Kendra (Female, US English)' },
  { value: 'Kimberly', label: 'Kimberly (Female, US English)' },
  { value: 'Kevin', label: 'Kevin (Male, US English)' },
  { value: 'Ivy', label: 'Ivy (Female Child, US English)' },
  { value: 'Justin', label: 'Justin (Male Child, US English)' },
  { value: 'Ruth', label: 'Ruth (Female, US English, Generative)' },
  { value: 'Stephen', label: 'Stephen (Male, US English, Generative)' },
  { value: 'Amy', label: 'Amy (Female, UK English)' },
  { value: 'Brian', label: 'Brian (Male, UK English)' },
  { value: 'Emma', label: 'Emma (Female, UK English)' },
  { value: 'Celine', label: 'Céline (Female, French)' },
  { value: 'Mathieu', label: 'Mathieu (Male, French)' },
  { value: 'Lea', label: 'Léa (Female, French)' },
  { value: 'Chantal', label: 'Chantal (Female, Canadian French)' },
  { value: 'Penelope', label: 'Penélope (Female, US Spanish)' },
  { value: 'Miguel', label: 'Miguel (Male, US Spanish)' },
  { value: 'Lupe', label: 'Lupe (Female, US Spanish)' },
];

export const POLLY_ENGINES = [
  { value: 'neural', label: 'Neural — highest quality' },
  { value: 'generative', label: 'Generative — most natural' },
  { value: 'long-form', label: 'Long-form — conversational' },
  { value: 'standard', label: 'Standard — lowest cost' },
];

export const AWS_REGIONS = [
  { value: 'us-east-1', label: 'US East (N. Virginia)' },
  { value: 'us-west-2', label: 'US West (Oregon)' },
  { value: 'ca-central-1', label: 'Canada (Central)' },
  { value: 'eu-west-1', label: 'Europe (Ireland)' },
  { value: 'eu-west-2', label: 'Europe (London)' },
  { value: 'ap-southeast-1', label: 'Asia Pacific (Singapore)' },
  { value: 'ap-southeast-2', label: 'Asia Pacific (Sydney)' },
];

export const PERSONA_TONES = ['friendly', 'professional', 'warm', 'formal'];

export const LANGUAGES = [
  { value: 'en-US', label: 'English (US)' },
  { value: 'en-CA', label: 'English (CA)' },
  { value: 'en-GB', label: 'English (UK)' },
  { value: 'fr-CA', label: 'French (CA)' },
  { value: 'fr-FR', label: 'French (FR)' },
  { value: 'es-US', label: 'Spanish (US)' },
];

export const LEAD_FIELDS = ['name', 'email', 'phone', 'callback_time', 'unit_interest'];

export const LEAD_STATUSES = ['new', 'contacted', 'scheduled', 'closed', 'spam'];

export const SESSION_STATUSES = [
  'initiated', 'ringing', 'in_progress', 'completed', 'failed', 'no_answer', 'busy', 'canceled',
];

export const WEEK_DAYS = [
  { num: 0, label: 'Sun' },
  { num: 1, label: 'Mon' },
  { num: 2, label: 'Tue' },
  { num: 3, label: 'Wed' },
  { num: 4, label: 'Thu' },
  { num: 5, label: 'Fri' },
  { num: 6, label: 'Sat' },
];

export const emptyVoiceConfig = () => ({
  voice_slug: '',
  is_active: true,

  persona: {
    assistant_name: 'Aria',
    tone: 'friendly',
    language: 'en-US',
    speaking_rate: 1.0,
    filler_words_enabled: true,
    intro_message: "Hi there! Thanks for calling. I'm your virtual assistant. How can I help you today?",
    goodbye_message: "Thanks for calling! Have a wonderful day. Goodbye!",
  },

  stt: {
    provider: 'transcribe',
    model: 'default',
    language: 'en-US',
    punctuate: true,
    interim_results: true,
    endpointing_ms: 800,
  },

  tts: {
    provider: 'polly',
    voice_id: 'Joanna',
    model_id: '',
    stability: 0.5,
    similarity_boost: 0.75,
    output_format: 'pcm',
    engine: 'neural',
  },

  ai: {
    model: 'anthropic.claude-haiku-4-5-20251001-v1:0',
    max_tokens_per_turn: 200,
    temperature: 0.7,
    system_prompt: '',
    knowledge_base: '',
    lead_collection_prompt: "When the caller shows interest in scheduling or getting more info, naturally ask for their name, email, and phone number one at a time.",
    fallback_message: "I'm sorry, I didn't catch that. Let me connect you with our team who can better assist you.",
    max_conversation_turns: 20,
  },

  integrations: {
    connect_phone_number: '',
    connect_instance_id: '',
    connect_contact_flow_id: '',
    aws_region: 'us-east-1',
    notification_email: '',
    notification_email_name: 'Team',
    crm_webhook: '',
    property_id: '',
    booking_url: '',
  },

  call_limits: {
    max_call_duration_seconds: 600,
    max_concurrent_calls: 3,
    business_hours_only: false,
    business_hours_start: '09:00',
    business_hours_end: '17:00',
    business_days: [1, 2, 3, 4, 5],
    outside_hours_message: "Thanks for calling! Our office is currently closed. Please call back during business hours.",
    blocked_numbers: [],
  },

  lead_config: {
    auto_collect: true,
    required_fields: ['name', 'email', 'phone'],
    ask_for_callback_time: true,
    send_confirmation_sms: false,
    confirmation_sms_message: "Thanks for your interest! Our team will reach out to you shortly.",
  },
});

export const setNestedValue = (obj, path, value) => {
  const keys = path.split('.');
  if (keys.length === 1) return { ...obj, [keys[0]]: value };
  if (keys.length === 2) return { ...obj, [keys[0]]: { ...obj[keys[0]], [keys[1]]: value } };
  if (keys.length === 3) return {
    ...obj,
    [keys[0]]: {
      ...obj[keys[0]],
      [keys[1]]: { ...obj[keys[0]][keys[1]], [keys[2]]: value },
    },
  };
  if (keys.length === 4) return {
    ...obj,
    [keys[0]]: {
      ...obj[keys[0]],
      [keys[1]]: {
        ...obj[keys[0]][keys[1]],
        [keys[2]]: { ...obj[keys[0]][keys[1]][keys[2]], [keys[3]]: value },
      },
    },
  };
  return obj;
};

export const deepMerge = (target, source) => {
  const result = { ...target };
  for (const key of Object.keys(source || {})) {
    if (
      source[key] !== null &&
      typeof source[key] === 'object' &&
      !Array.isArray(source[key])
    ) {
      result[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
};

export const formatDuration = (seconds = 0) => {
  if (!seconds) return '—';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
};

export const formatDate = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-CA', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

export const formatCost = (usd = 0) => `$${Number(usd).toFixed(4)}`;

export const LEAD_STATUS_COLORS = {
  new: { color: '#1D4ED8', background: '#EFF6FF', border: '#BFDBFE' },
  contacted: { color: '#D97706', background: '#FFFBEB', border: '#FDE68A' },
  scheduled: { color: '#7C3AED', background: '#F5F3FF', border: '#DDD6FE' },
  closed: { color: '#059669', background: '#ECFDF5', border: '#6EE7B7' },
  spam: { color: '#DC2626', background: '#FEF2F2', border: '#FECACA' },
};

export const SESSION_STATUS_COLORS = {
  completed: '#059669',
  in_progress: '#1D4ED8',
  failed: '#DC2626',
  no_answer: '#D97706',
  busy: '#D97706',
  canceled: '#94A3B8',
  initiated: '#64748B',
  ringing: '#0D9488',
};